import _taggedTemplateLiteral from "@babel/runtime/helpers/esm/taggedTemplateLiteral";
var _templateObject;
import gql from 'graphql-tag';
var AdsFillrateEventsMutation = gql(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  mutation SendAdsFillrateEvents($input: SendAdsFillrateEventsInput!) {\n    sendAdsFillrateEvents(input: $input) {\n      status\n    }\n  }\n"])));
export default AdsFillrateEventsMutation;